<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1C6nVER/tc-custom/9783987446139.jpg?1704425334863" alt="This image is the cover for the book Nordenholt's Million, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nordenholt's Million, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Disaster novel in which denitrifying bacteria inimical to plant growth run amok and destroy world agriculture. The eponymous plutocrat Nordenholt constructs a refuge for the chosen few in Scotland, roofing over the Clyde valley. (Goodreads)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        J. J. Connington
      </h2>
      
      <p class="authorDescription body article">Alfred Walter Stewart (5 September 1880 – 1 July 1947) was a British chemist and part-time novelist who wrote seventeen detective novels and a pioneering science fiction work between 1923 and 1947 under the pseudonym of JJ Connington. He created several fictional detectives, including Superintendent Ross and Chief Constable Sir Clinton Driffield.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?fd42666e